import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useScrollToTop } from '../../helpers/hooks/useScrollToTop';
import usePageTitle from '../../services/hooks/usePageTitle';
import Appointment from '../Appointment/Appointment';

const Change: FC = () => {
  const { t } = useTranslation();

  usePageTitle(t('pageTitle:change'));
  useScrollToTop();

  return (
    <Appointment title={t('appointment:editTitle')} />
  );
};

export default Change;
